var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31726 2.48682C4.73147 2.48682 5.06726 2.8226 5.06726 3.23682L5.06726 12.0894L5.51675 11.64C5.80964 11.3471 6.28452 11.3471 6.57741 11.64C6.8703 11.9328 6.8703 12.4077 6.57741 12.7006L4.86429 14.4137C4.72364 14.5544 4.53288 14.6334 4.33396 14.6334C4.13505 14.6334 3.94429 14.5544 3.80363 14.4137L2.09052 12.7006C1.79763 12.4077 1.79763 11.9328 2.09052 11.64C2.38341 11.3471 2.85829 11.3471 3.15118 11.64L3.56726 12.056L3.56726 3.23682C3.56726 2.8226 3.90304 2.48682 4.31726 2.48682ZM6.934 4.5C6.934 4.08579 7.26979 3.75 7.684 3.75H8.01734C8.43155 3.75 8.76734 4.08579 8.76734 4.5C8.76734 4.91421 8.43155 5.25 8.01734 5.25H7.684C7.26979 5.25 6.934 4.91421 6.934 4.5ZM6.934 7.15457C6.934 6.74036 7.26979 6.40457 7.684 6.40457H10.684C11.0982 6.40457 11.434 6.74036 11.434 7.15457C11.434 7.56879 11.0982 7.90457 10.684 7.90457H7.684C7.26979 7.90457 6.934 7.56879 6.934 7.15457ZM6.934 10C6.934 9.58579 7.26979 9.25 7.684 9.25H13.5C13.9142 9.25 14.25 9.58579 14.25 10C14.25 10.4142 13.9142 10.75 13.5 10.75H7.684C7.26979 10.75 6.934 10.4142 6.934 10Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sortDown.ae3fe08670b6557e8734bb688422f607.svg";
export { ForwardRef as ReactComponent };